import { SlateNode } from '@src/components/sco/RichMarkdownInput'
import { EditorElementTypes } from '@src/components/sco/RichMarkdownInput/components/Element'
import { isHotkey } from 'is-hotkey'
import { Editor, Element as SlateElement, Point, Range, Transforms } from 'slate'

const IS_DEV = process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== 'production'

export const MARKDOWN_TRIGGERS: { [hotkey: string]: string } = {
  // '*': EditorElementTypes.LIST_ITEM,
  // '-': EditorElementTypes.LIST_ITEM,
  // '+': EditorElementTypes.LIST_ITEM,
  '>': EditorElementTypes.BLOCK_QUOTE,
  '`': EditorElementTypes.CODE_BLOCK,
  '#': IS_DEV ? EditorElementTypes.PARAGRAPH : EditorElementTypes.HEADING_ONE,
  '##': IS_DEV ? EditorElementTypes.PARAGRAPH : EditorElementTypes.HEADING_TWO,
  '###': IS_DEV ? EditorElementTypes.PARAGRAPH : EditorElementTypes.HEADING_THREE,
  '####': IS_DEV ? EditorElementTypes.PARAGRAPH : EditorElementTypes.HEADING_FOUR,
  '#####': IS_DEV ? EditorElementTypes.PARAGRAPH : EditorElementTypes.HEADING_FIVE,
  '######': IS_DEV ? EditorElementTypes.PARAGRAPH : EditorElementTypes.HEADING_SIX,
}

export function withMarkdownDetection(editor, options = {}) {
  const { onKeyDown, deleteBackward, insertText } = editor

  editor.onKeyDown = (editor, event) => {
    if (isHotkey('mod+Enter', event as any)) {
    }

    if (onKeyDown) {
      onKeyDown(editor, event)
    }
  }

  editor.insertText = text => {
    const { selection } = editor

    if (text && text.endsWith(' ') && selection && Range.isCollapsed(selection)) {
      const { anchor } = selection
      const block = Editor.above(editor, {
        match: n => SlateElement.isElement(n) && Editor.isBlock(editor, n),
      })
      const path = block ? block[1] : []
      const start = Editor.start(editor, path)
      const range = { anchor, focus: start }
      const beforeText = Editor.string(editor, range) + text.slice(0, -1)
      const type = MARKDOWN_TRIGGERS[beforeText]

      if (type) {
        Transforms.select(editor, range)

        if (!Range.isCollapsed(range)) {
          Transforms.delete(editor)
        }

        const newProperties: Partial<SlateNode> = {
          type,
        }
        Transforms.setNodes<SlateElement>(editor, newProperties, {
          match: n => SlateElement.isElement(n) && Editor.isBlock(editor, n),
        })

        if (type === EditorElementTypes.LIST_ITEM) {
          const list = {
            type: EditorElementTypes.UL_LIST,
            children: [],
          }
          Transforms.wrapNodes(editor, list, {
            match: (n: SlateNode) =>
              !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === EditorElementTypes.LIST_ITEM,
          })
        }

        return
      }
    }

    if (insertText) {
      insertText(text)
    }
  }

  editor.deleteBackward = (...args) => {
    const { selection } = editor

    if (selection && Range.isCollapsed(selection)) {
      const match = Editor.above(editor, {
        match: (n: SlateNode) => SlateElement.isElement(n) && Editor.isBlock(editor, n),
      })

      if (match) {
        const block = match[0] as SlateNode
        const path = match[1]
        const start = Editor.start(editor, path)

        if (
          !Editor.isEditor(block) &&
          SlateElement.isElement(block) &&
          block.type !== EditorElementTypes.PARAGRAPH &&
          Point.equals(selection.anchor, start)
        ) {
          const newProperties: Partial<SlateNode> = {
            type: EditorElementTypes.PARAGRAPH,
          }
          Transforms.setNodes(editor, newProperties)

          if (block.type === EditorElementTypes.LIST_ITEM_TEXT) {
            Transforms.unwrapNodes(editor, {
              match: (n: SlateNode) =>
                !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === EditorElementTypes.LIST_ITEM,
              split: true,
            })
          }

          return
        }
      }

      if (deleteBackward) {
        deleteBackward(...args)
      }
    }
  }

  return editor
}
